const l = (t, e, c) => {
  const r = { ...t };
  return r[e] || (r[e] = []), r[e] = [.../* @__PURE__ */ new Set([...r[e], c])], r;
}, u = (t, e, c) => {
  var n;
  const r = { ...t };
  return r[e] = r[e].filter((i) => i !== c), (n = r[e]) != null && n.length || delete r[e], r;
}, s = (t = {}) => Object.values(t).reduce((e, c) => e + c.length, 0), v = (...t) => t.filter(Boolean).join(" ");
function d(t) {
  return o(t);
}
function o(t) {
  return Math.round(t * 100) / 100;
}
export {
  l as addToActiveFilters,
  d as calculatePrice,
  v as classNames,
  s as countActiveFilters,
  u as removeFromActiveFilters,
  o as roundPrices
};
//# sourceMappingURL=helpers.js.map
